import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { TOGGLE_DMX_CONTROLLER_STATUS } from './actionTypes';
import { toggleDmxControllerStatusSuccessful, toggleDmxControllerStatusFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* toggleControllerStatus({ payload: { controller } }) {
  try {
    const response = yield call(
      dmxAPI.toggleControllerStatus,
      controller.token,
      controller.id,
      controller.active,
    );
    if (response.message) {
      yield put(toggleDmxControllerStatusSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(toggleDmxControllerStatusFailed(error));
  }
}

export function* watchToggleDmxControllerStatus() {
  yield takeEvery(TOGGLE_DMX_CONTROLLER_STATUS, toggleControllerStatus);
}

function* toggleDmxControllerStatusSaga() {
  yield all([fork(watchToggleDmxControllerStatus)]);
}

export default toggleDmxControllerStatusSaga;
